
import { AssetsUserDetailsMetadataBase } from './assets-user-details.metadata.base';


export class AssetsUserDetailsMetadata extends AssetsUserDetailsMetadataBase {
  constructor() {
    super();
  }
}

export const ASSETS_USER_DETAILS_METADATA: AssetsUserDetailsMetadata = new AssetsUserDetailsMetadata();


